import { TaggedSlugEntityPublicApiService } from './taggedSlugEntityPublicApiService';
import { Glossary } from '@models/glossary';

export class GlossaryPublicService extends TaggedSlugEntityPublicApiService<Glossary> {
    constructor() {
        super('/api/glossary');
    }
}
